import { Box, BoxProps } from "@chakra-ui/react";

export const VerticalGroup = (props: BoxProps) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      gap="0.75rem"
      {...props}
    />
  );
};
